export default {
  WRTC: "WRTC",
  TRTC: "TRTC",
  URTC: "URTC",
};
